import { computed } from 'vue'

export function useErrorMessage(isSubmitting: any, formErrors: any) {
  const errorMessage = computed(() => {
    if (formErrors.value && Object.keys(formErrors.value).length > 0 && !isSubmitting.value) {
      const errors = Object.values(formErrors.value)
      const requiredErrors = errors.filter((error: any) => error.includes('required'))

      if (requiredErrors.length > 0) {
        return 'Please fill in all the required fields to proceed'
      }

      return errors[0]
    }

    return ''
  })

  return { errorMessage }
}
